<template>
  <div class="title" v-if="data.type === 'parts'">
    <div class="title_parts">
      <span :title="data.data.name">半成品</span>
      <span class="text-center">{{ data.data.name }}KG</span>
      <span class="text-center">{{ data.weight }}KG</span>
      <span>{{ data.percentage }}%</span>
      <span style="float:right" @click="gd()">
        <a v-show="!show">
          查看详情
          <a-icon type="down" />
        </a>
        <a v-show="show">
          收起
          <a-icon type="up" />
        </a>
      </span>
    </div>
    <view-formula-sen v-show="show" style="background-color: #f9f9f9;" :data="data.data.formula" />
  </div>
  <div class="title_rawMaterial title" v-else>
    <span :title="data.data.name">原材料</span>
    <span class="text-center">{{data.data.name}}</span>
    <span class="text-center">{{ data.weight }}KG</span>
    <span>{{ data.percentage }}%</span>
    <span></span>
  </div>
</template>

<script>
import ViewFormulaSen from './viewFormulaSen'
export default {
  syncProps: ['data'],
  props: {
    data: {
      type: Object,
      reuired: true
    }
  },
  data () {
    return {
      show: false
    }
  },
  methods: {
    gd () {
      this.show = !this.show
    }
  },
  components: {
    ViewFormulaSen
  }
}
</script>

<style scoped>
.title_rawMaterial,
.title_parts {
  height: 50px;
  line-height: 50px;
  font-size: 14px;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
}
/* .title_rawMaterial p,
.title_parts p {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
} */
.title_rawMaterial span,.title_parts span {
  flex:1
}
.title {
  border-bottom: 1px solid #e5e7ea;
}
</style>
